import type { Messages, TranslateFn } from '@/i18n/types';

export function createTranslator(messages: Messages, fallback: Messages): TranslateFn {
  return (key, vars) => {
    let text = messages[key] ?? fallback[key] ?? key;
    if (vars) {
      for (const [k, v] of Object.entries(vars)) {
        text = text.replaceAll(`{${k}}`, String(v));
      }
    }
    return text;
  };
}
